var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 80,
    viewBox: "0 0 255 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1176_8816)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 255,
    height: 80,
    rx: 10,
    fill: "#0D4BB0"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1176_8816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.949 43.1035H251.755V60.1544C251.755 72.7872 241.478 83.0648 228.845 83.0648H196.104V85.259C196.104 94.6607 203.753 102.309 213.154 102.309H248.181L266.195 117.321C266.731 117.768 267.398 118 268.071 118C269.681 118 271 116.693 271 115.07V60.1544C271 50.7383 263.382 43.1035 253.949 43.1035Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.896 60.1547V35.0509C245.896 25.618 238.262 18 228.845 18H188.051C178.618 18 171 25.634 171 35.0509V89.9666C171 91.5886 172.318 92.8962 173.929 92.8962C174.602 92.8962 175.269 92.6643 175.805 92.2165L193.819 77.2056H228.845C238.247 77.2056 245.896 69.5572 245.896 60.1547ZM208.448 64.6537C206.831 64.6537 205.518 63.3415 205.518 61.7241C205.518 60.1066 206.831 58.7944 208.448 58.7944C210.065 58.7944 211.378 60.1066 211.378 61.7241C211.378 63.3415 210.065 64.6537 208.448 64.6537ZM211.378 51.6967V52.3102C211.378 53.9276 210.066 55.2398 208.448 55.2398C206.83 55.2398 205.518 53.9276 205.518 52.3102V49.1722C205.518 47.554 206.83 46.2425 208.448 46.2425C211.158 46.2425 213.363 44.0368 213.363 41.3269C213.363 38.6161 211.158 36.4113 208.448 36.4113C207.133 36.4113 205.899 36.9224 204.971 37.8502C204.044 38.7779 203.533 40.0116 203.533 41.3231C203.533 42.9413 202.221 44.255 200.603 44.255C198.985 44.255 197.673 42.9443 197.673 41.3269V41.3231C197.673 38.4468 198.794 35.7414 200.828 33.7074C202.863 31.6726 205.567 30.5519 208.444 30.5519C214.389 30.5519 219.222 35.3859 219.222 41.3269C219.222 46.2532 215.9 50.4181 211.378 51.6967Z",
    fill: "white",
    fillOpacity: 0.2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1176_8816"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 255,
    height: 80,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1176_8816"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(171 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard2);
export default __webpack_public_path__ + "static/media/card_2.cc265e6f7ab94c4e1f82caac116ec61e.svg";
export { ForwardRef as ReactComponent };